export const SET_REQUIRED_FIELDS_FILTERS = 'SET_REQUIRED_FIELDS_FILTERS';

export const RESET_REQUIRED_FIELDS_FILTERS = 'RESET_REQUIRED_FIELDS_FILTERS';

export const SET_REQUIRED_FIELDS_GRID_SORT_CRITERIA = 'SET_REQUIRED_FIELDS_GRID_SORT_CRITERIA';
